import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker
} from "@material-ui/pickers";
import TimerIcon from "@material-ui/icons/Timer";
import DateFnsUtils from "@date-io/date-fns";
import { parse } from "date-fns";
import classNames from "classnames";
import timePickerStyles from "../styles/TimePicker.styles";

const defaultDuration = "00:00:00";

const DurationPicker = ({
	label,
	value = defaultDuration,
	handleDurationChange = () => {},
	views = ["hours", "minutes", "seconds"],
	size = "medium",
	hideDialog = false,
	helperText,
	error
}) => {
	const classes = timePickerStyles();
	const timeFormat = "HH:mm:ss";

	const isValidDuration = (duration) =>
		!Number.isNaN(parse(duration, timeFormat, new Date()).getTime());

	const hasDurationChanged = (duration) => duration !== value;

	const [isOpen, setIsOpen] = useState(false);

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<Box
				className={classNames(classes.clockTimePickerBox, {
					[classes.hiddenDialog]: hideDialog
				})}
			>
				<KeyboardTimePicker
					size={size}
					onOpen={() => setIsOpen(true)}
					onClose={() => setIsOpen(false)}
					open={isOpen}
					fullWidth
					keyboardIcon={<TimerIcon />}
					DialogProps={{ className: classes.clockTimePicker }}
					margin="normal"
					id="duration-picker"
					label={label}
					onChange={(_, duration) => {
						if (hasDurationChanged(duration) && isValidDuration(duration)) {
							handleDurationChange(duration);
						}
					}}
					onBlur={(e) => {
						const { value: duration } = e.target;
						if (hasDurationChanged(duration)) {
							handleDurationChange(isValidDuration(duration) ? duration : value);
						}
					}}
					onClear={() => {
						if (hasDurationChanged(defaultDuration)) {
							handleDurationChange(defaultDuration);
						}
						setIsOpen(false);
					}}
					KeyboardButtonProps={{
						"aria-label": "change duration"
					}}
					value={parse(value, timeFormat, new Date())}
					ampm={false}
					clearable
					clearLabel="Reset"
					format={timeFormat}
					views={views}
					helperText={helperText}
					error={error}
				/>
			</Box>
		</MuiPickersUtilsProvider>
	);
};

export default DurationPicker;
